module.exports = __webpack_public_path__ + "node_modules/nitro-components/build/assets/images/placeholder-vehicle.png";


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/assets/images/placeholder-vehicle.png
// module id = 2307
// module chunks = 4